export { default } from "../src/load";
